import { getABNVariant } from '~/src/helpers/abn-tests';

const isFullBuyVillage = (): boolean => {
    return getABNVariant('fullbuy_village') === 'fullbuy_village_enable';
};

export default isFullBuyVillage;
